import { Typography } from '@scale/scaleui';
import { ISensorFusionUnifiedProjectLookupDto } from '@scale/sensor-fusion-shared';

import { openSelectedIfUrl } from '../helpers/url';
import { ReactJsonView } from 'react-scale/corp/components/ReactJsonView';

type SfuJSONPanelProps = {
  project: ISensorFusionUnifiedProjectLookupDto;
};

const SfuJSONPanel = ({ project }: SfuJSONPanelProps) => {
  return (
    <div className="border border-solid border-neutral-200 px-4 py-4 flex flex-col gap-2">
      <Typography.H3>JSON</Typography.H3>
      <ReactJsonView
        src={project}
        name={false}
        theme="monokai"
        iconStyle="triangle"
        collapsed={1}
        onSelect={openSelectedIfUrl}
        collapseStringsAfterLength={120}
        groupArraysAfterLength={false}
        enableClipboard={true}
        displayObjectSize={false}
        displayDataTypes={false}
      />
    </div>
  );
};

export default SfuJSONPanel;
